export default {
    http_timeout: process.env.REACT_APP_HTTP_TIMEOUT || 5000,
    url: process.env.REACT_APP_API_URL || 'https://estate-pos-api.kuladigital.com',
}